import { InputArchivoEndosoMasivo } from "../models/inputArchivoEndosoMasivo";
import { RowRecaudacionEndosoMasivo } from "../models/rowRecaudacionEndosoMasivo";
import { enviarExcelEndosoMasivo, recaudarEndososMasivos } from "../services/recaudacionEndosoMasivoService";

export default function UseRecaudacionEndosoMasivo(){

    const cargarArchivo = async (e: InputArchivoEndosoMasivo) => {
        const response = await enviarExcelEndosoMasivo(e);
        return response;
    }   

    const recaudarEndoso = async (e: RowRecaudacionEndosoMasivo[]) => {
        const response = await recaudarEndososMasivos(e);
        return response;
    }

    return {
        cargarArchivo,
        recaudarEndoso
    }
}